import { CancelLodgingRequestState, CancelLodgingRequestActionTypes, CANCEL_LODGING_REQUEST_REQUEST, CANCEL_LODGING_REQUEST_SUCCESS, CANCEL_LODGING_REQUEST_FAILURE } from "store/reducers/lodgingRequest/cancel/types";

const defaultState: CancelLodgingRequestState = {
  isLoading: false,
  errorMessage: ""
};

export default function cancelLodgingRequest(state = defaultState, action: CancelLodgingRequestActionTypes): CancelLodgingRequestState {
  switch (action.type) {
    case CANCEL_LODGING_REQUEST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case CANCEL_LODGING_REQUEST_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case CANCEL_LODGING_REQUEST_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};